import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../barcodeform.css";
import * as XLSX from "xlsx";
// import bulkExport from '../../img/bulk_template/medical_task.csv';
import jQuery from "jquery";
import { getApiBaseUrl } from "../../utils/utils";

export default function TaskCreation({ isNewMode = false }) {
  const API_URL = process.env.REACT_APP_API_URL;
  const [shipmentDetails, setShipmentDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const $ = jQuery.noConflict();

  // Generate short unique reference for Normal orders
  // Format: N-YYMMDD-XXXX (e.g., N-260121-B3K9)
  const generateShortRef = (prefix = "N", index = 0) => {
    const now = new Date();
    const yy = String(now.getFullYear()).slice(-2);
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");
    const dateStr = `${yy}${mm}${dd}`;
    
    // Generate 4-char alphanumeric code (A-Z, 0-9)
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"; // Exclude confusing chars: I,O,0,1
    let code = "";
    const timestamp = now.getTime();
    const seed = timestamp + index;
    
    for (let i = 0; i < 4; i++) {
      const randomIndex = (seed + Math.floor(Math.random() * 1000) + i * 7) % chars.length;
      code += chars[randomIndex];
    }
    
    return `${prefix}-${dateStr}-${code}`;
  };

  const [scaninfo, setScaninfo] = useState({
    task_file: "",
    from_date: "",
    to_date: "",
  });

  useEffect(() => {
    $(".btn-demo.import").on("click", function () {
      $(".nalier.middle-center.fade").css("display", "block");
      $(".nalier.middle-center.fade").addClass("in");
    });

    $(".close.h-close").on("click", function () {
      $(".nalier.middle-center.fade.in").css("display", "none");
      $(".nalier.middle-center.fade").removeClass("in");
      window.dispatchEvent(new Event("modalClosed"));
    });

    $(".close.h-close2").on("click", function () {
      $(".nalier.middle-center2.fade.in").css("display", "none");
      $(".nalier.middle-center2.fade").removeClass("in");
    });
  }, []);

  const buttonsyle = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginRight: "10px",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
  };
  const buttonsyle1 = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    // marginLeft: '75%',
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
    marginBottom: "10%",
  };

  const [msg, setMsg] = useState("");
  const [errormsg, setError] = useState("");

  useEffect(() => {
    // Fetch drivers from the API on component mount
    fetchDrivers();
  }, []);

 

  const [drivers, setDrivers] = useState();
  const [awb, setAwb] = useState();
  const fetchDrivers = async () => {
    try {
      // Replace this API endpoint with the actual one that fetches drivers based on the emirate
      const response = await axios.get(
        `${API_URL}shypvdriverapp/driver/getAllDrivers`
      );

      if (response.data.success) {
        const driversData = response.data.data; // The array of driver objects

        // Map the response to extract driverId and name
        const driversList = driversData.map((driver) => ({
          driver_id: driver.driverId,
          driver_name: driver.name,
        }));

        // Set the drivers state
        setDrivers(driversList);
      } else {
        console.error("Error fetching drivers for emirate:");
      }
    } catch (error) {
      console.error("Error fetching drivers:", error);
    }
  };

  const [errors, setErrors] = useState({});
  const [successAWBs, setSuccessAWBs] = useState([]);
    const [validRows, setValidRows] = useState([]);
    const [invalidRows, setInvalidRows] = useState([]);
  const [showCreateTooltip, setShowCreateTooltip] = useState(false);
  
  // State for inline editing of valid rows
  const [editingCell, setEditingCell] = useState(null); // { rowId, key }
  const [editValue, setEditValue] = useState("");
  
  console.log("drivers:", drivers);
  console.log("scan:", scaninfo);

  const [errorNew, seterrorNew] = useState("");

  //   const [updatedDetails, setUpdatedDetails] = useState(shipmentDetails);
  const [newStatus, setnewStatus] = useState(0);
  // Handle status change

  console.log("shipmentDetails", shipmentDetails);

  const [parsedData, setParsedData] = useState([]);

  function Reset() {
    setParsedData([]);
      setValidRows([]);
      setInvalidRows([]);
      setEditingCell(null);
      setEditValue("");
  }

    const handleResetClick = () => {
      if (window.confirm("Are you sure you want to reset all data?")) {
        Reset();
      }
    };

    // Handle double-click to start editing a valid row cell
    const handleValidCellDoubleClick = (rowId, key, currentValue) => {
      setEditingCell({ rowId, key });
      setEditValue(currentValue || "");
    };

    // Handle saving edited value on Enter key
    const handleValidCellKeyDown = (e, rowId, key) => {
      if (e.key === "Enter") {
        e.preventDefault();
        // Update the valid row with new value
        setValidRows((prev) =>
          prev.map((row) =>
            row.__rowId === rowId ? { ...row, [key]: editValue } : row
          )
        );
        setEditingCell(null);
        setEditValue("");
      } else if (e.key === "Escape") {
        setEditingCell(null);
        setEditValue("");
      }
    };

    // Handle blur to save when clicking outside
    const handleValidCellBlur = (rowId, key) => {
      setValidRows((prev) =>
        prev.map((row) =>
          row.__rowId === rowId ? { ...row, [key]: editValue } : row
        )
      );
      setEditingCell(null);
      setEditValue("");
    };

    const validateMedicalRow = (row) => {
      const errors = [];
      const errorFields = [];
      const required = [
        "Reference",
        "Trip Number",
        "Task Type",
        "Team Id",
        "Homebase Id ( Drop off)",
        "Sender City",
        "Location Id ( Pickup)",
        "Consignee City",
        "Drop Start Time",
        "Drop End Time",
      ];

      required.forEach((key) => {
        if (!row[key] || `${row[key]}`.toString().trim() === "") {
          errors.push(`${key} is required`);
          errorFields.push(key);
        }
      });

      if (row["Trip Number"] && isNaN(parseInt(row["Trip Number"], 10))) {
        errors.push("Trip Number must be a number");
        if (!errorFields.includes("Trip Number")) errorFields.push("Trip Number");
      }

      return { isValid: errors.length === 0, errors, errorFields };
    };

    const distributeRows = (rows) => {
      const valid = [];
      const invalid = [];

      rows.forEach((row, index) => {
        const { isValid, errors, errorFields } = validateMedicalRow(row);
        if (isValid) {
          valid.push({ ...row, __rowId: index });
        } else {
          invalid.push({ ...row, __rowId: index, __errors: errors, __errorFields: errorFields });
        }
      });

      setValidRows(valid);
      setInvalidRows(invalid);
    };

    const handleInvalidEdit = (rowId, key, value) => {
      const updated = invalidRows.map((row) => {
        if (row.__rowId === rowId) {
          const updatedRow = { ...row, [key]: value };
          const { isValid, errors, errorFields } = validateMedicalRow(updatedRow);
          return { ...updatedRow, __errors: errors, __errorFields: errorFields, __isNowValid: isValid };
        }
        return row;
      });
      setInvalidRows(updated);
    };

    const handleAddToValid = (rowId) => {
      const rowToMove = invalidRows.find((r) => r.__rowId === rowId);
      if (!rowToMove || !rowToMove.__isNowValid) return;

      const { __errors, __isNowValid, ...cleanRow } = rowToMove;
      setValidRows((prev) => [...prev, cleanRow]);
      setInvalidRows((prev) => prev.filter((r) => r.__rowId !== rowId));
    };

    const handleRemoveRow = (rowId) => {
      if (window.confirm("Are you sure you want to remove this row?")) {
        setInvalidRows((prev) => prev.filter((r) => r.__rowId !== rowId));
      }
    };

  function bulkUpload() {
    if (
      scaninfo.task_file &&
      scaninfo.from_date &&
      scaninfo.to_date &&
      scaninfo.partner_id
    ) {
      // Validate date range
      if (new Date(scaninfo.from_date) > new Date(scaninfo.to_date)) {
        seterrorNew("From Date cannot be greater than To Date");
        return;
      }
      seterrorNew("");
      setErrors([]);
      setSuccessAWBs([]);

      const file = scaninfo.task_file;
      const reader = new FileReader();

      reader.onload = function (e) {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const rawJson = XLSX.utils.sheet_to_json(worksheet, {
          defval: "",
          raw: true,
        });

        const processedJson = rawJson.map((row) => {
          const newRow = {};
          Object.entries(row).forEach(([key, value]) => {
            if (
              typeof value === "number" &&
              key.toLowerCase().includes("time")
            ) {
              const totalMinutes = Math.round(value * 24 * 60);
              const hours = Math.floor(totalMinutes / 60);
              const minutes = totalMinutes % 60;

              // Format to HH:mm (24-hour format)
              newRow[key] = `${hours.toString().padStart(2, "0")}:${minutes
                .toString()
                .padStart(2, "0")}`;
            } else {
              newRow[key] = value;
            }
          });
          return newRow;
        });

        console.log("Parsed Excel Data with Formatted Dates:", processedJson);
        if (isNewMode) {
          setParsedData(processedJson);
          distributeRows(processedJson);
        } else {
          setParsedData(processedJson);
        }
      };

      reader.readAsArrayBuffer(file);
    } else {
      seterrorNew("Please fill the required details");
    }
  }

  const [progress, setProgress] = useState(0);
  const [statusMessage, setStatusMessage] = useState("");

  function createTask() {
    setLoading(true);
    setProgress(0);
    setStatusMessage("Starting task creation...");

    // Helper to generate array of dates between from_date and to_date
    const getDateRange = (startDate, endDate) => {
      const dates = [];
      const currentDate = new Date(startDate);
      const lastDate = new Date(endDate);
      
      while (currentDate <= lastDate) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return dates;
    };

    // Helper to convert 12-hour time to 24-hour ISO string for a specific date
    const convertToISOTime = (timeStr, targetDate) => {
      // Split the time string into hours, minutes, and AM/PM modifier
      const [time, modifier] =
        timeStr.includes("AM") || timeStr.includes("PM")
          ? timeStr.split(/(AM|PM)/i).map((s) => s.trim())
          : [timeStr, null];

      // Parse hours and minutes from the time string
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier) {
        if (modifier.toUpperCase() === "PM" && hours < 12) hours += 12;
        if (modifier.toUpperCase() === "AM" && hours === 12) hours = 0;
      }

      // Use the target date
      const taskCreationDate = new Date(targetDate);

      // Set the hours and minutes on the target date
      taskCreationDate.setHours(hours);
      taskCreationDate.setMinutes(minutes || 0);
      taskCreationDate.setSeconds(0);
      taskCreationDate.setMilliseconds(0);

      // Manually format the date in the 'YYYY-MM-DDTHH:mm:ss' format
      const year = taskCreationDate.getFullYear();
      const month = (taskCreationDate.getMonth() + 1)
        .toString()
        .padStart(2, "0");
      const day = taskCreationDate.getDate().toString().padStart(2, "0");
      const formattedHours = taskCreationDate
        .getHours()
        .toString()
        .padStart(2, "0");
      const formattedMinutes = taskCreationDate
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const formattedSeconds = taskCreationDate
        .getSeconds()
        .toString()
        .padStart(2, "0");

      return `${year}-${month}-${day}T${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    };

    const sourceRows = isNewMode ? validRows : parsedData;

    if (isNewMode && invalidRows.length > 0) {
      seterrorNew("Please fix all invalid rows before submitting.");
      setLoading(false);
      return;
    }

    // Get all dates in the range
    const dateRange = getDateRange(scaninfo.from_date, scaninfo.to_date);
    const totalDates = dateRange.length;
    
    setStatusMessage(`Processing orders for ${totalDates} date(s)...`);

    // Create orders for each date in the range
    let completedDates = 0;
    let allSuccessAWBs = [];
    let allErrors = {};

    const processDate = async (targetDate, dateIndex) => {
      const dateStr = targetDate.toISOString().split('T')[0];
      setStatusMessage(`Processing date ${dateIndex + 1}/${totalDates}: ${dateStr}...`);

      const medOrders = sourceRows.map((row) => ({
        awb: row["Reference"],
        driverId: row["Driver Id"] ? `${row["Driver Id"]}`.trim() : "",
        tripNumber: parseInt(row["Trip Number"]),
        taskType: row["Task Type"].toLowerCase(),
        teamId: row["Team Id"],
        homebaseId: row["Homebase Id ( Drop off)"],
        locationId: row["Location Id ( Pickup)"],
        sCity: row["Sender City"],
        conCity: row["Consignee City"],
        dropStartTime: convertToISOTime(row["Drop Start Time"], targetDate),
        dropEndTime: convertToISOTime(row["Drop End Time"], targetDate),
        orderDate: dateStr,
      }));

      const payload = [
        {
          partnerId: parseInt(scaninfo.partner_id),
          medOrders: medOrders,
        },
      ];

      try {
        const response = await axios.post(
          `${API_URL}shypvdriverapp/jobs/createMedOrder`,
          payload,
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.data.success) {
          const jobId = response.data.data.jobId;
          
          // Poll for results
          const pollForResults = () => {
            return new Promise((resolve, reject) => {
              let attempts = 0;
              const maxRetries = 50;
              let interval = 3000;

              const poll = () => {
                axios
                  .get(`${API_URL}shypvdriverapp/jobs/createGenOrder/results/${jobId}`)
                  .then((resultResponse) => {
                    const result = resultResponse.data;
                    if (result.success && result.data) {
                      resolve(result.data);
                    } else {
                      attempts++;
                      if (attempts < maxRetries) {
                        interval = Math.min(interval * 1.5, 15000);
                        setTimeout(poll, interval);
                      } else {
                        reject(new Error("Timeout waiting for job results"));
                      }
                    }
                  })
                  .catch(reject);
              };

              setTimeout(poll, interval);
            });
          };

          const jobResult = await pollForResults();
          const orders = jobResult.orders || [];

          orders.forEach((order) => {
            if (order.status === "FAILED") {
              allErrors[`${dateStr}-${order.opsReference}`] = order.errorMessage;
            } else if (order.status === "SUCCESS") {
              allSuccessAWBs.push(order.shypvBkrefid);
            }
          });
        }
      } catch (error) {
        console.error(`Error processing date ${dateStr}:`, error);
        allErrors[dateStr] = error.message || "Failed to process";
      }

      completedDates++;
      setProgress((completedDates / totalDates) * 100);
    };

    // Process all dates sequentially
    const processAllDates = async () => {
      for (let i = 0; i < dateRange.length; i++) {
        await processDate(dateRange[i], i);
      }

      setProgress(100);
      setStatusMessage(`✅ Orders processed for ${totalDates} date(s)!`);
      setErrors(allErrors);
      setSuccessAWBs(allSuccessAWBs);
      setLoading(false);
    };

    processAllDates();
  }

  const [partners, setPartners] = useState([]);
  useEffect(() => {
    const fetchPartners = async () => {
      const baseApiUrl = getApiBaseUrl();
      try {
        const response = await axios.get(
          `${baseApiUrl}/v1.0/partner/retrieve_list?page=0`
        );
        setPartners(
          (response.data.data || []).filter(
            (partner) => partner.accountType.toLowerCase() === "medical"
          )
        );
      } catch (err) {
        setError(err.message || "Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchPartners();
  }, []);

  const buttonStyle = {
    background: "#00a6ed",
    color: "#fff",
    marginRight: "10px",
    fontWeight: 600,
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "0.2rem",
    padding: "4px 6px",
    border: "none",
    height: "30px",
  };

  function PrintLabel(awbs) {
    if (!awbs || awbs.length === 0) {
      console.warn("No AWBs to print.");
      return;
    }

    // Normalize AWBs to a comma-separated list
    const awbList = awbs.map((item) => item.trim()).filter(Boolean);
    const awbParam = awbList.join(",");

    // Determine base URL based on current hostname
    const currentHost = window.location.hostname;
    let baseUrl;

    if (currentHost.includes("stage-tms-dashboard.shypv.com")) {
      baseUrl = "https://business-agent-stage.shypv.com";
    } else if (currentHost.includes("tms-dashboard.shypv.com")) {
      baseUrl = "https://business-agent.shypv.com";
    } else {
      console.warn("Unknown environment. Defaulting to production.");
      baseUrl = "https://business-agent.shypv.com";
    }

    const url = `${baseUrl}/multi-print-order?id=${awbParam}`;

    console.log("Generated URL:", url);
    window.open(url, "_blank");
  }

  return (
    <div>
      <div className="form-container" style={{ margin: "20px" }}>
        <div className="row">
          <div className="col-md-6">
            <h5 style={{ float: "left" }}>Medical Task Creation</h5>
          </div>
          {/* <a href={bulkExport} download="medical_task" className="panel-title my-wallet-rec " style={buttonStyle}> Download Template </a> */}
          <a
            href="/bulk_template/medical_task.csv"
            download="medical_bulk_upload.csv"
            className="panel-title my-wallet-rec"
            style={buttonStyle}
          >
            Download Template
          </a>
        </div>

        <div className="row">
          <div className="col-md-6">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="from_date">From Date:</label>
                  <input
                    type="date"
                    id="from_date"
                    onChange={(e) =>
                      setScaninfo({
                        ...scaninfo,
                        from_date: e.target.value,
                      })
                    }
                    value={scaninfo.from_date}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="to_date">To Date:</label>
                  <input
                    type="date"
                    id="to_date"
                    onChange={(e) =>
                      setScaninfo({
                        ...scaninfo,
                        to_date: e.target.value,
                      })
                    }
                    value={scaninfo.to_date}
                  />
                </div>
              </div>
            </div>
            {scaninfo.from_date && scaninfo.to_date && (
              <div style={{ 
                background: "#e8f1fa", 
                padding: "8px 12px", 
                borderRadius: "4px", 
                marginBottom: "10px",
                fontSize: "13px"
              }}>
                <strong>Date Range:</strong> {scaninfo.from_date} to {scaninfo.to_date}
                {" "}
                ({(() => {
                  const start = new Date(scaninfo.from_date);
                  const end = new Date(scaninfo.to_date);
                  const diffTime = Math.abs(end - start);
                  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
                  return `${diffDays} day(s)`;
                })()})
              </div>
            )}
            <div className="form-group">
              <label htmlFor="date">Partner</label>
              <select
                onChange={(e) =>
                  setScaninfo({ ...scaninfo, partner_id: e.target.value })
                }
                value={scaninfo.partner_id}
              >
                <option value="" disabled>
                  -- Select a partner --
                </option>
                <option value="0">select</option>
                {partners &&
                  [...partners]
                    .sort((a, b) => a.pname.localeCompare(b.pname))
                    .map((partner) => (
                      <option key={partner.pid} value={partner.pid}>
                        {partner.pname}
                      </option>
                    ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="time">Task File:</label>
              <input
                type="file"
                id="task_file"
                onChange={(e) =>
                  setScaninfo({ ...scaninfo, task_file: e.target.files[0] })
                }
              />
            </div>

            <a
              onClick={bulkUpload}
              style={{ ...buttonsyle, marginTop: "6%" }}
              type="button"
              className="btn-demo add"
            >
              {isNewMode ? "View Data" : "Submit"}
            </a>

            {isNewMode && (
              <a
                onClick={handleResetClick}
                style={{
                  ...buttonsyle,
                  marginTop: "6%",
                  marginLeft: "10px",
                  background: "#c1121f",
                  borderColor: "#c1121f",
                }}
                type="button"
                className="btn-demo add"
              >
                Reset
              </a>
            )}

            <p style={{ color: "red" }}>{errorNew}</p>
          </div>

          <div className="col-md-6">
            {successAWBs.length > 0 && (
              <button
                style={{
                  background: "#06003c",
                  border: "#06003c",
                  color: "#fff",
                }}
                onClick={() => PrintLabel(successAWBs)}
              >
                Print Label
              </button>
            )}

            {Object.keys(errors).length > 0 && (
              <div
                className="alert alert-danger"
                style={{ marginTop: "20px", background: "#f7292930" }}
              >
                <h4>Failed Orders: {Object.keys(errors).length}</h4>
                <ul style={{ listStyle: "none" }}>
                  {Object.entries(errors).map(([ref, msg]) => (
                    <li key={ref}>
                      <strong>{ref}</strong>: {msg}
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {successAWBs.length > 0 && (
              <div
                className="alert "
                style={{ marginTop: "20px", background: "#bdcded" }}
              >
                <h4>Successful Orders (AWBs): {successAWBs.length}</h4>
                <ul style={{ listStyle: "none" }}>
                  {successAWBs.map((awb, i) => (
                    <li key={i}>{awb}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-11">
            {parsedData.length > 0 && (
              <div>
                <div className="row" style={{ marginTop: "4%" }}>
                  <div className="col-md-8">
                    {" "}
                    <h3>Parsed CSV Data</h3>
                  </div>
                  <div className="col-md-4">
                    <div className="row">
                      <div className="col-md-12 text-end mt-2 mb-2">
                        {!isNewMode && (
                          <>
                            <a
                              onClick={() => createTask()}
                              className="btn-demo add me-2"
                              style={{
                                ...buttonsyle,
                                marginTop: "6%",
                                marginBottom: "2%",
                              }}
                              type="button"
                            >
                              Create Task
                            </a>
                            <a
                              onClick={Reset}
                              className="btn-demo add"
                              style={{
                                ...buttonsyle,
                                marginTop: "6%",
                                marginBottom: "2%",
                              }}
                              type="button"
                            >
                              Reset
                            </a>
                          </>
                        )}
                      </div>
                      <p>{loading ? "processing..." : ""}</p>
                      {loading && (
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                          <p>{statusMessage}</p>
                          <div
                            style={{
                              height: "10px",
                              width: "100%",
                              backgroundColor: "#eee",
                              borderRadius: "5px",
                              marginTop: "10px",
                            }}
                          >
                            <div
                              style={{
                                height: "10px",
                                width: `${progress}%`,
                                backgroundColor: "#007bff",
                                borderRadius: "5px",
                                transition: "width 0.5s ease",
                              }}
                            ></div>
                          </div>
                          <p>{Math.round(progress)}%</p>
                        </div>
                      )}
                    </div>
                    {/* <div className="row">
                                            <div className="col-md-6">
                                                <a onClick={createTask} style={{ ...buttonsyle, marginTop: '6%', float: 'right', marginBottom: '2%' }} type="button" className="btn-demo add">
                                                    Create Task
                                                </a>
                                                <p>{loading ? 'processing...' : ''}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <a onClick={Reset} style={{ ...buttonsyle, marginTop: '6%', float: 'right', marginBottom: '2%' }} type="button" className="btn-demo add">
                                                    Reset
                                                </a>
                                            </div>
                                        </div> */}
                  </div>
                </div>

                {!isNewMode && (
                  <table
                    style={{
                      borderCollapse: "collapse",
                      width: "100%",
                      backgroundColor: "#7995e9a6",
                    }}
                  >
                    <thead>
                      <tr>
                        {Object.keys(parsedData[0]).map((key) => (
                          <th
                            key={key}
                            style={{ border: "1px solid #000", padding: "8px" }}
                          >
                            {key}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {parsedData.map((row, index) => (
                        <tr key={index}>
                          {Object.values(row).map((value, i) => (
                            <td
                              key={i}
                              style={{ border: "1px solid #000", padding: "8px" }}
                            >
                              {value}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                {isNewMode && (
                  <>
                    <div className="row" style={{ marginTop: "20px", marginBottom: "10px" }}>
                      <div className="col-md-4">
                        <div style={{ background: "#e8f1fa", padding: "12px", borderRadius: "6px", border: "1px solid #c5d9ed" }}>
                          <strong>Actual Rows</strong>
                          <div style={{ fontSize: "20px" }}>{parsedData.length}</div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div style={{ background: "#e6f5eb", padding: "12px", borderRadius: "6px", border: "1px solid #b8d4c2" }}>
                          <strong>Valid Rows</strong>
                          <div style={{ fontSize: "20px" }}>{validRows.length}</div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div style={{ background: "#fef3e6", padding: "12px", borderRadius: "6px", border: "1px solid #e8d5b8" }}>
                          <strong>Invalid Rows</strong>
                          <div style={{ fontSize: "20px" }}>{invalidRows.length}</div>
                        </div>
                      </div>
                    </div>

                    <h4 style={{ textAlign: "left" }}>Valid Data <span style={{ fontSize: "12px", fontWeight: "normal", color: "#666" }}>(Double-click to edit, Enter to save)</span></h4>
                    <div style={{ overflowX: "auto", marginBottom: "20px", width: "100%" }}>
                      <table
                        style={{
                          borderCollapse: "separate",
                          borderSpacing: 0,
                          width: "100%",
                          minWidth: "100%",
                          tableLayout: "auto",
                          fontSize: "12px",
                          border: "1px solid #c5d9ed",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <thead>
                          <tr>
                            {Object.keys(parsedData[0]).map((key) => (
                              <th key={key} style={{ border: "1px solid #c5d9ed", padding: "6px", whiteSpace: "nowrap", backgroundColor: "#e8f1fa", color: "#333" }}>
                                {key}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {validRows.length === 0 && (
                            <tr>
                              <td colSpan={Object.keys(parsedData[0]).length} style={{ padding: "8px" }}>
                                No valid rows yet.
                              </td>
                            </tr>
                          )}
                          {validRows.map((row) => (
                            <tr key={row.__rowId} style={{ backgroundColor: "#e6f5eb" }}>
                              {Object.entries(row)
                                .filter(([key]) => !key.startsWith("__"))
                                .map(([key, value]) => {
                                  const isEditing = editingCell?.rowId === row.__rowId && editingCell?.key === key;
                                  return (
                                    <td 
                                      key={key} 
                                      style={{ 
                                        border: "1px solid #c5d9ed", 
                                        padding: isEditing ? "2px" : "6px",
                                        cursor: "pointer",
                                        backgroundColor: isEditing ? "#fff" : "transparent"
                                      }}
                                      onDoubleClick={() => handleValidCellDoubleClick(row.__rowId, key, value)}
                                    >
                                      {isEditing ? (
                                        <input
                                          type="text"
                                          value={editValue}
                                          onChange={(e) => setEditValue(e.target.value)}
                                          onKeyDown={(e) => handleValidCellKeyDown(e, row.__rowId, key)}
                                          onBlur={() => handleValidCellBlur(row.__rowId, key)}
                                          autoFocus
                                          style={{
                                            width: "100%",
                                            padding: "4px",
                                            border: "2px solid #00a6ed",
                                            borderRadius: "3px",
                                            fontSize: "12px",
                                            outline: "none"
                                          }}
                                        />
                                      ) : (
                                        value
                                      )}
                                    </td>
                                  );
                                })}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <h4 style={{ textAlign: "left" }}>Invalid Data </h4>
                    <div style={{ overflowX: "auto", width: "100%" }}>
                      <table
                        style={{
                          borderCollapse: "separate",
                          borderSpacing: 0,
                          width: "100%",
                          minWidth: "100%",
                          tableLayout: "auto",
                          fontSize: "12px",
                          border: "1px solid #c5d9ed",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <thead>
                          <tr>
                            {Object.keys(parsedData[0]).map((key) => (
                              <th key={key} style={{ border: "1px solid #c5d9ed", padding: "6px", whiteSpace: "nowrap", backgroundColor: "#e8f1fa", color: "#333" }}>
                                {key}
                              </th>
                            ))}
                            <th style={{ border: "1px solid #c5d9ed", padding: "6px", whiteSpace: "nowrap", backgroundColor: "#e8f1fa", color: "#333", minWidth: "200px" }}>Errors</th>
                          </tr>
                        </thead>
                        <tbody>
                          {invalidRows.length === 0 && (
                            <tr>
                              <td colSpan={Object.keys(parsedData[0]).length + 1} style={{ padding: "8px" }}>
                                No invalid rows.
                              </td>
                            </tr>
                          )}
                          {invalidRows.map((row) => (
                            <tr 
                              key={row.__rowId}
                              style={{
                                backgroundColor: row.__isNowValid ? "#e6f5eb" : "#fef3e6",
                              }}
                            >
                              {Object.entries(row)
                                .filter(([key]) => !key.startsWith("__"))
                                .map(([key, value]) => {
                                  const hasError = row.__errorFields?.includes(key);
                                  return (
                                    <td key={key} style={{ border: "1px solid #c5d9ed", padding: "4px", backgroundColor: hasError ? "#fbe8e8" : "transparent" }}>
                                      <span
                                        style={{
                                          display: "block",
                                          fontSize: "12px",
                                          color: hasError ? "#dc3545" : "#333",
                                          padding: "2px 4px",
                                        }}
                                      >
                                        {value}
                                      </span>
                                    </td>
                                  );
                                })}
                              <td style={{ border: "1px solid #c5d9ed", padding: "4px", minWidth: "200px" }}>
                                {row.__isNowValid ? (
                                  <span style={{ color: "green" }}>✓ Valid</span>
                                ) : (
                                  <ul style={{ paddingLeft: "18px", margin: 0, fontSize: "11px", color: "#dc3545" }}>
                                    {row.__errors?.map((err, idx) => (
                                      <li key={idx}>{err}</li>
                                    ))}
                                  </ul>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div style={{ textAlign: "right", marginTop: "12px" }}>
                      <span
                        style={{ position: "relative", display: "inline-block" }}
                        onMouseEnter={() => {
                          if (invalidRows.length > 0) setShowCreateTooltip(true);
                        }}
                        onMouseLeave={() => setShowCreateTooltip(false)}
                      >
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            if (invalidRows.length > 0) return;
                            createTask();
                          }}
                          className="btn-demo add me-2"
                          style={{
                            ...buttonsyle,
                            marginTop: "6%",
                            marginBottom: "2%",
                            display: "inline-block",
                            ...(invalidRows.length > 0
                              ? { opacity: 0.6, cursor: "not-allowed" }
                              : {}),
                          }}
                          type="button"
                        >
                          Create Task
                        </a>
                        {invalidRows.length > 0 && showCreateTooltip && (
                          <div
                            style={{
                              position: "absolute",
                              right: "105%",
                              top: "50%",
                              transform: "translateY(-50%)",
                              backgroundColor: "#D3D3D3",
                              color: "#E41B17",
                              padding: "6px 8px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              whiteSpace: "nowrap",
                              zIndex: 9999,
                            }}
                          >
                            Please fix all invalid rows before submitting.
                          </div>
                        )}
                      </span>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
